<template>
  <div class="proposal__wrap">
    <div class="fdfdf crumbs__wrap">
      <el-button
        class="backBtn"
        @click="$router.go(-1)"
        plain
        icon="el-icon-d-arrow-left"
        size="mini"
        >返回</el-button
      >
      &nbsp;&nbsp;&nbsp;
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/agent' }"
          >代理管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>邀请用户（{{ nickname }}）</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params">
        <el-form-item label="" prop="school_id">
          <el-select
            v-model="table.params.school_id"
            filterable
            clearable
            placeholder="请选择代理学校"
            @change="handleSearch"
          >
            <el-option
              v-for="item in schools"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="salesman_id">
          <el-select
            v-model="table.params.salesman_id"
            filterable
            clearable
            placeholder="请选择邀请人"
            @change="handleSearch"
          >
            <el-option
              v-for="item in salesman"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="is_vip">
          <el-select
            v-model="table.params.is_vip"
            filterable
            clearable
            placeholder="请选择是否会员"
            @change="handleSearch"
          >
            <el-option
              v-for="item in vip"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getTable"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:is_vip="{ row }">
          {{ ["非会员", "会员"][row.is_vip] }}
        </template>
        <template v-slot:sex="{ row }">
          {{ ["女", "男", "女"][row.sex] }}
        </template>
      </VTable>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "SalesmanList",
  mixins: [mixinTable],
  components: {
    VTable,
  },
  data() {
    return {
      field: [
        { name: "name", label: "用户名", hidden: false },
        { name: "account", label: "手机号", hidden: false },
        { name: "sex", label: "性别", hidden: false },
        { name: "school_name", label: "大学名称", hidden: false },
        { name: "education", label: "学历", hidden: false },
        { name: "major_name", label: "专业", hidden: false },
        { name: "salesman_name", label: "邀请人", hidden: false },
        { name: "create_time", label: "注册日期", hidden: false },
        { name: "is_vip", label: "是否会员", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          type: 1,
          agent_id: "",
          school_id: "",
          salesman_id: "",
          is_vip: 0,
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      nickname: "",
      schools: [],
      salesman: [],
      vip: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "是",
        },
        {
          id: 2,
          name: "否",
        },
      ],
    };
  },
  created() {
    this.table.params.agent_id = this.$route.query.agent_id;
    this.nickname = this.$route.query.nickname;
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/agent/student", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.schools = res.data.schools;
            if (this.schools.length === 1) {
              this.table.params.school_id = this.schools[0].id;
            }
            this.salesman = res.data.salesman;
            if (this.salesman.length === 1) {
              this.table.params.salesman_id = this.salesman[0].id;
            }
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 删除
    handleDelete(row) {
      this.$confirm("请确认删除操作?", "提示", {
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.$http.post("/admin/agent/del", { id: row.id }).then((res) => {
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }

  .crumbs__wrap {
    margin-bottom: 20px;
  }
}
.fdfdf {
  display: flex;
  align-items: center;
}
</style>